import React from 'react';

export default function Index() {
  return <p>Appid</p>;
}
